export const DEFAULT_LABELKEY = 'label';
export const SIZES = ['lg', 'sm'] as const;
